/**
 * Header Menu are used by application
 * navigate resources in the header
 */
export enum HeaderMenu {
  SEARCH = 'Search',
  CATALOG = 'Catalog',
  RESOURCES = 'Resources',
  TRAINING = 'Training',
  SIGN_IN = 'Sign in',
  MY_DASHBOARD = 'My Dashboard',
  EDIT_PROFILE = 'Update Profile',
  MESSAGES = 'Messages',
  PRODUCTS = 'Subscriptions',
  SIGN_OUT = 'Sign Out',
  CHANGE_PASSWORD = 'Change Password',
}
